export const incomelists = [
  {
    key: 1,
    Date: "24 Dec 2024",
    Reference: "IN849",
    Store: "Distribution center",
    Category: "Foreign investment",
    Notes: "Categorize income derived",
    Amount: "$200",
  },
  {
    key: 2,
    Date: "10 Dec 2024",
    Reference: "IN848",
    Store: "Intelligent warehouse",
    Category: "Product Export",
    Notes: "Services that have been verified",
    Amount: "$50",
  },
  {
    key: 3,
    Date: "27 Nov 2024",
    Reference: "IN847",
    Store: "Mahin Logistics",
    Category: "Installation",
    Notes: "POS Installation for Store",
    Amount: "$800",
  },
  {
    key: 4,
    Date: "06 Nov 2024",
    Reference: "IN845",
    Store: "Bonded warehouse",
    Category: "Local Sale",
    Notes: "Travel fare for client meeting",
    Amount: "$700",
  },
  {
    key: 5,
    Date: "25 Oct 2024",
    Reference: "IN844",
    Store: "Budget warehouse",
    Category: "Service Fees",
    Notes: "Services that have been verified",
    Amount: "$1000",
  },
  {
    key: 6,
    Date: "14 Oct 2024",
    Reference: "IN843",
    Store: "Gati Limited",
    Category: "Return/Refund Income",
    Notes: "Flight tickets for meetings",
    Amount: "$1200",
  },
  {
    key: 7,
    Date: "03 Oct 2024",
    Reference: "IN842",
    Store: "Storeroom Halls",
    Category: "Foreign investment",
    Notes: "Services that have been verified",
    Amount: "$750",
  },
  {
    key: 8,
    Date: "20 Sep 2024",
    Reference: "IN841",
    Store: "Strongbox",
    Category: "Product Export",
    Notes: "Categorize income derived in office",
    Amount: "$450",
  },
  {
    key: 9,
    Date: "10 Sep 2024",
    Reference: "IN840",
    Store: "Total Quality Logistics",
    Category: "Return/Refund Income",
    Notes: "Services that have been verified",
    Amount: "$300",
  },
];
